import { API_REQUEST_STATES } from 'store/apiRequestStates/constants';

export function selectIsAppLoading({ app }) {
	return app.isLoading === API_REQUEST_STATES.REQUEST;
}

export const selectLocale = ({ app }) => app?.locale || 'en';

export const selectLastView = ({ app }) => app?.lastView;
